import { render, staticRenderFns } from "./CascadingPermissionsProfileSelect.vue?vue&type=template&id=24dc6b1b&scoped=true"
import script from "./CascadingPermissionsProfileSelect.vue?vue&type=script&lang=js"
export * from "./CascadingPermissionsProfileSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc6b1b",
  null
  
)

export default component.exports